import PropTypes from 'prop-types';
import React, {Component} from 'react';
import path from 'path';

import {events} from 'lib';

import {Row, Col} from 'components';
import InstructionsView from 'components/tools/InstructionsView';
import SystemSelectCard from './SystemSelectCard';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {mergeableSystems, mergesForTarget} from 'helpers/systemMerge';

class Instructions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: new Set(),
    };
  }

  start = systems => {
    if (systems.length !== 2) {
      events.publish('error.user', {message: this.props.intl.formatMessage({id: 'merge.instructions.select.two'})});
      return;
    }

    this.props.selectSystems(...systems);
  };

  select = ({key, value}) => {
    let selected = this.state.selected;

    if (value) {
      selected.add(key);
    } else {
      selected.delete(key);
    }

    this.setState({selected});
  };

  start = systems => {
    if (systems.length !== 2) {
      events.publish('error.user', {message: <FormattedMessage id='merge.instructions.select.two'/>});
      return;
    }

    this.props.selectSystems(...systems);
  };

  render() {
    let allSystems = mergeableSystems(this.props.customer.pools);
    let eligibleSystems = allSystems;
    let {formatMessage} = this.props.intl;

    if (this.state.selected.size === 1) {
      eligibleSystems = mergesForTarget(allSystems.find(x => x.id === parseInt([...this.state.selected][0])), allSystems);
    } else if (this.state.selected.size >= 2) {
      eligibleSystems = [...this.state.selected].map(x => allSystems.find(y => y.id === parseInt(x)));
    }

    return <div>
      <InstructionsView
        title={formatMessage({id: 'merge.select.systems'})}
        remember={[
          formatMessage({id: 'merge.system.water.test'}),
          formatMessage({id: 'merge.only.two.systems'}),
          formatMessage({id: 'merge.product.profile.preferences'}),
        ]}
        cancelHref={path.join(location.hash, '..', '..')} onSubmit={() => this.start(eligibleSystems)}>

        <div>
          <h3 className='blue' style={{marginTop: 20, marginBottom: 15}}><FormattedMessage id="merge.instructions.select.two" /></h3>
          <Row>
            {allSystems.map(x => {
              let disabled = !eligibleSystems.find(y => y.id === x.id);

              return <Col key={x.id} md={4}>
                <SystemSelectCard pool={x} customer={this.props.customer} disabled={disabled} onChange={this.select} formatMessage={formatMessage} />
              </Col>;
            })}
          </Row>
        </div>

      </InstructionsView>
    </div>;
  }
}

Instructions.propTypes = {
  customer: PropTypes.object.isRequired,
  selectSystems: PropTypes.func.isRequired,
};

export default injectIntl(Instructions);
